// extracted by mini-css-extract-plugin
export var avatarContainer = "_bn-0";
export var avatarTypingWave = "_bn-i";
export var gray = "_bn-f";
export var green = "_bn-c";
export var icon = "_bn-9";
export var image = "_bn-1";
export var lg = "_bn-6";
export var md = "_bn-5";
export var presenceDot = "_bn-b";
export var red = "_bn-d";
export var sm = "_bn-4";
export var status = "_bn-a";
export var typingDot = "_bn-h";
export var typingPill = "_bn-g";
export var xl = "_bn-7";
export var xs = "_bn-3";
export var xxl = "_bn-8";
export var xxs = "_bn-2";
export var yellow = "_bn-e";